// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gw-0";
export var animationContainer = "_gw-1";
export var itemPrice = "_gw-a";
export var itemizedContent = "_gw-9";
export var itemizedHeader = "_gw-7";
export var itemizedRow = "_gw-8";
export var itemizedSection = "_gw-6";
export var modalContent = "_gw-2";
export var orderName = "_gw-3";
export var refundOption = "_gw-4";
export var refundOptionsContainer = "_gw-5";
export var shippingLabel = "_gw-b";
export var totalRow = "_gw-c";